import { ref, onUnmounted, watchEffect } from 'vue';
import { getAccount, watchAccount,disconnect } from '@wagmi/core';
import { wagmiConfig } from './wagmiConfig';
import Fetch from './fetch';
import router from '@/router';

export function useAccount() {
  const loginAccount = ref(getAccount(wagmiConfig));

  const unwatch = watchAccount(wagmiConfig, {
    onChange: (newAccount) => {
      console.log('newAccount', newAccount);
      if (newAccount && newAccount.address) {
        if (newAccount.address !== localStorage.getItem('userAddress')) {
          localStorage.setItem('userAddress', newAccount.address);
          const t_mobile = localStorage.getItem('inviter');
          const agent = localStorage.getItem('agent');
          Fetch("/index/login", {
            userAddress: newAccount.address,
            agent: agent,
            t_mobile: t_mobile
          }).then((res) => {
            if (res.data && res.data.token) {
              localStorage.setItem('token', res.data.token);
              router.push('/index');
            }
          }).catch((error) => {
            console.error('Login error:', error);
          });
        }
      } else {
		   console.log('Handle disconnect');
		   logout();
        // Handle disconnect logic if needed
      }
      loginAccount.value = newAccount;
    },
  });

  // Cleanup on unmount
  onUnmounted(() => {
    if (unwatch) {
      unwatch();
    }
  });
	const logout = async () => {
		console.log('logouting');
		await disconnect(wagmiConfig);
		localStorage.removeItem('token');
		localStorage.removeItem('userAddress');
		loginAccount.value = null;
		// router.push('/');
	};
	// 使用 watchEffect 监听账户变化
  watchEffect(() => {
	if (!loginAccount.value) {
	  logout();
	}
  });
  return { loginAccount , logout };
}
